angular.module('swapick')
.controller('RegisterCtrl',  RegisterCtrl);

function RegisterCtrl ($auth, $rootScope, authService, $ionicSideMenuDelegate, DataService, clientId,
        clientSecret, $http, Entities, $ionicLoading, $state, $openFB ) {


    this.credentials = {
        email:'',
        emailRepeat:'',
        password: '',
        username:''
    };

    this.errors = null;


    this.register = () =>{
        $ionicLoading.show()

        // Prepare the Good API Object
        const credentials = {
          email: this.credentials.email,
          username: this.credentials.username,
          plainPassword: {
            first: this.credentials.password,
            second: this.credentials.password
          }
        };

        DataService.users
        .post({ 'fos_user_registration_form' : credentials})
        //$auth.login(this.credentials)
        .then(response => {
            this.errors = null

            console.log("registration success", response);
            setTimeout(function(){
                $ionicLoading.hide();
                $state.go('app.registration-done');
            }, 200)


        })
        .catch(response => {
            console.error("registration error", response);
            this.errors = response.data ? response.data.errors : {error:'Impossibile effettuare la registrazione'};
            console.error(1, this.errors)
            $ionicLoading.hide();

        });

    }

    this.registerFacebook = () => {

      var fbLoginSuccess = function (userData) {
        console.log("UserInfo: ", userData);
      }

      var fbLoginError = function(error) {
        console.error(error)
      }

      //return facebookConnectPlugin.login(["public_profile"], fbLoginSuccess, fbLoginError);


      $ionicLoading.show()
      return $openFB.login({scope: 'email,user_friends'})
      .then((token) => {
          console.log(100, token)
          return $openFB.api({path: '/me', params : {fields: 'email'}})
          .then((res) => {
              console.log("me api", res);

              const credentials = {
                email: res.email,
                username: this.credentials.username,
                facebookAccessToken: token.authResponse.token,
                facebookId: res.id,
                plainPassword: {
                  first: this.credentials.password,
                  second: this.credentials.password
                }
              };

              DataService.users
              .post({ 'fos_user_registration_form' : credentials})
              .then(response => {
                  this.errors = null
                  console.log("registration success", response);
                  setTimeout(function(){
                    $ionicLoading.hide();
                    $state.go('app.registration-done');
                  }, 200)
              })
              .catch(response => {
                console.error("registration error", response);
                this.errors = response.data ? response.data.errors : {error:'Impossibile effettuare la registrazione'};
                console.error(1, this.errors)
                $ionicLoading.hide();
              });
            },
            function( err ) {
              // error
              $ionicLoading.hide()
            }
          );
      }, function( err ) {
          $ionicLoading.hide()
          console.error("e", err)
      });

    }



}



// WEBPACK FOOTER //
// ./src/controllers/register-controller.js